/* eslint-disable */
import React from 'react';
import { useGetApplication } from '~/controllers/wizard';
import { Stage } from '~/types/Application';
import { isAgent } from '~/utils/getDecodedJwt';
import Review from '~/pages/ksa/review';
import AgentCompletedOnboarding from './completedOnboarding/agent';
import MerchantCompletedOnboarding from './completedOnboarding/merchant';

import MerchantOnboardingInProgress from './components/MerchantOnboardingInProgress';
import AgentManualOnboarding from './manualOnboarding/agent';
import AgentAutomatedOnboarding from './automatedOnboarding/agent';
import TechFailedOnboarding from './techFailedOnboarding/agent';
import FailedOnboarding from './failedOnboarding/agent';

import ReviewReject from './reviewReject';
import Terminated from './terminated';

const Completion: React.FC<void> = () => {
  const applicationQuery = useGetApplication();
  if (!applicationQuery.data) return null;

  const currentStage = applicationQuery.data.stage;

  switch (currentStage) {
    case Stage.ksaCompletedOnboarding:
      if (isAgent()) {
        // @ts-ignore
        return <Review />;
      }
      return <MerchantOnboardingInProgress />;

    case Stage.ksaAutomatedOnboarding:
      if (isAgent()) {
        // @ts-ignore
        return <Review />;
      }
      return <MerchantOnboardingInProgress />;

    case Stage.ksaReviewReject:
      if (isAgent()) {
        // @ts-ignore
        return <Review />;
      }
      return <ReviewReject />;
    case Stage.ksaTerminated:
      if (isAgent()) {
        // @ts-ignore
        return <Review />;
      }
      return <Terminated />;
    case Stage.ksaTechFailedOnboarding:
      if (isAgent()) {
        // @ts-ignore
        return <Review />;
      }
      return <MerchantOnboardingInProgress />;
    default:
      if (!isAgent()) {
        return <MerchantOnboardingInProgress />;
      }
      switch (currentStage) {
        case Stage.ksaManualOnboarding:
          if (isAgent()) {
            // @ts-ignore
            return <Review />;
          }
          return <AgentManualOnboarding />;
        case Stage.ksaFailedOnboarding:
          if (isAgent()) {
            // @ts-ignore
            return <Review />;
          }
          return <MerchantOnboardingInProgress />;
        default:
        // must not be here
      }
  }

  return null;
};

export default Completion;
